import type { EditorCommand } from '@atlaskit/editor-common/types/editor-command';

import { type MalleableUiPluginMeta, malleableUiPluginKey } from '../pm-plugins/plugin-key';

/**
 * Mark a node's variant-picker update as in-flight so the rovo-bridge update
 * processors skip the BE-pushed insert. `id` is either `historyEntry.fieldId`
 * (image) or the MAUI app id from `historyEntry.url` (MAUI); the two id
 * spaces don't collide.
 */
export function makeTrackVariantUpdateStartCommand({ id }: { id: string }): EditorCommand {
	return ({ tr }) => {
		tr.setMeta(malleableUiPluginKey, {
			addInFlightVariantUpdateId: id,
		} satisfies MalleableUiPluginMeta);
		return tr;
	};
}

/**
 * Counterpart to `makeTrackVariantUpdateStartCommand`. Dispatched by
 * `useOnComplete` once the FE insertion settles.
 */
export function makeTrackVariantUpdateCompleteCommand({ id }: { id: string }): EditorCommand {
	return ({ tr }) => {
		tr.setMeta(malleableUiPluginKey, {
			removeInFlightVariantUpdateId: id,
		} satisfies MalleableUiPluginMeta);
		return tr;
	};
}
